import { render, staticRenderFns } from "./AppContentImport.vue?vue&type=template&id=dbcc0c26&"
import script from "./AppContentImport.vue?vue&type=script&lang=js&"
export * from "./AppContentImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports